import React from 'react';
import { Clock, MapPin, ChurchIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const EventDetails = () => {
  const navigate = useNavigate();
  const handleRsvpClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/rsvp');
  };
  const events = [{
    title: 'Traditional Wedding',
    date: 'March 20th, 2026',
    time: '11:00 AM',
    location: 'Traditional Wedding Venue',
    address: 'Benin, Edo State, Nigeria (Venue details shared with RSVP guests)',
    icon: <ChurchIcon size={28} className="text-emerald" data-id="element-36" />
  }, {
    title: 'White Wedding',
    date: 'March 28th, 2026',
    time: '11:00 AM',
    location: 'White Wedding Venue',
    address: 'Ibadan, Oyo State, Nigeria (Venue details shared with RSVP guests)',
    icon: <div size={28} className="text-emerald" data-id="element-37" />
  }];
  return <section id="events" className="bg-white py-20" data-id="element-38">
      <div className="section-container" data-id="element-39">
        <h2 className="section-heading" data-id="element-40">Event Details</h2>
        <div className="grid md:grid-cols-2 gap-10 max-w-5xl mx-auto" data-id="element-41">
          {events.map((event, index) => <div key={index} className="bg-cream border border-sage border-opacity-60 p-8 rounded-md shadow-sm hover:shadow-md transition-shadow" data-id="element-42">
              <div className="flex items-center mb-6" data-id="element-43">
                {event.icon}
                <h3 className="font-serif text-2xl ml-3 text-gray-800" data-id="element-44">
                  {event.title}
                </h3>
              </div>
              <div className="space-y-4" data-id="element-45">
                <div className="flex items-start" data-id="element-46">
                  <Clock size={20} className="text-emerald mt-1 mr-3 flex-shrink-0" data-id="element-47" />
                  <div data-id="element-48">
                    <p className="font-medium text-gray-800" data-id="element-49">{event.date}</p>
                    <p className="text-gray-600" data-id="element-50">{event.time}</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-51">
                  <MapPin size={20} className="text-emerald mt-1 mr-3 flex-shrink-0" data-id="element-52" />
                  <div data-id="element-53">
                    <p className="font-medium text-gray-800" data-id="element-54">
                      {event.location}
                    </p>
                    <p className="text-gray-600" data-id="element-55">{event.address}</p>
                  </div>
                </div>
              </div>
              <button onClick={handleRsvpClick} className="inline-block mt-6 px-5 py-2 border border-emerald text-emerald font-sans text-sm hover:bg-emerald hover:text-white transition-colors duration-300 cursor-pointer" data-id="element-56">
                RSVP for Details
              </button>
            </div>)}
        </div>
      </div>
    </section>;
};
export default EventDetails;